import { zIndexManager } from '../manager/zIndexManager';

export function zIndexTopDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: zIndexTopDirectiveCtrl,
	};
}

export class zIndexTopDirectiveCtrl {
	constructor($element) {
		'ngInject';
		zIndexManager.bringToTop($element);
	}
}
